const skinColors = {
  "Corporate Blue": {
    sidebar: "bg-gradient-to-b from-slate-900 via-blue-900 to-indigo-900",
    header: "bg-gradient-to-r from-blue-600 to-indigo-700",
    content: "bg-gradient-to-b from-blue-50 to-indigo-50",
    darkContent: "bg-gradient-to-br from-slate-900/95 via-blue-900/95 to-indigo-900/95",
    accent: "bg-blue-500",
    text: "text-white",
    name: "Corporate Blue",
    icon: "text-blue-300",
    hover: "hover:bg-blue-700",
    baseColor: "blue",
      baseShade: "500",
      glass: "backdrop-blur-md bg-white/80"
  },
  "Emerald Green": {
    sidebar: "bg-gradient-to-b from-gray-900 via-emerald-900 to-teal-900",
    header: "bg-gradient-to-r from-emerald-600 to-teal-700",
    content: "bg-gradient-to-b from-emerald-50 to-teal-50",
    darkContent: "bg-gradient-to-br from-gray-900/95 via-emerald-900/95 to-teal-900/95",
    accent: "bg-emerald-500",
    text: "text-white",
    name: "Emerald Green",
    icon: "text-emerald-300",
    hover: "hover:bg-emerald-700",
    baseColor: "emerald",
     baseShade: "500",
      glass: "backdrop-blur-md bg-white/80"
  },
  "Royal Purple": {
    sidebar: "bg-gradient-to-b from-gray-900 via-purple-900 to-violet-900",
    header: "bg-gradient-to-r from-purple-600 to-violet-700",
    content: "bg-gradient-to-b from-purple-50 to-violet-50",
    darkContent: "bg-gradient-to-br from-gray-900/95 via-purple-900/95 to-violet-900/95",
    accent: "bg-purple-500",
    text: "text-white",
    name: "Royal Purple",
    icon: "text-purple-300",
    hover: "hover:bg-purple-700",
    baseColor: "purple",
     baseShade: "500",
      glass: "backdrop-blur-md bg-white/80"
  },
  "Sunset Orange": {
    sidebar: "bg-gradient-to-b from-gray-900 via-orange-900 to-red-900",
    header: "bg-gradient-to-r from-orange-600 to-red-700",
    content: "bg-gradient-to-b from-orange-50 to-red-50",
    darkContent: "bg-gradient-to-br from-gray-900/95 via-orange-900/95 to-red-900/95",
    accent: "bg-orange-500",
    text: "text-white",
    name: "Sunset Orange",
    icon: "text-orange-300",
    hover: "hover:bg-orange-700",
         baseColor: "orange",
    baseShade: "500",
    glass: "backdrop-blur-md bg-white/80"
  },
  "Slate Gray": {
    sidebar: "bg-gradient-to-b from-gray-900 via-slate-800 to-gray-800",
    header: "bg-gradient-to-r from-slate-600 to-gray-700",
    content: "bg-gradient-to-b from-slate-50 to-gray-50",
    darkContent: "bg-gradient-to-br from-gray-900/95 via-slate-800/95 to-gray-800/95",
    accent: "bg-slate-500",
    text: "text-white",
    name: "Slate Gray",
    icon: "text-slate-300",
    hover: "hover:bg-slate-700",
    baseColor: "slate",
    baseShade: "500",
    glass: "backdrop-blur-md bg-white/80"
  }
};

export default skinColors;